import { CrudState } from "@/store/modules/crud/State";

export class State extends CrudState {
  dataList: Array<any> = [];
  dataItem: any | null = null;
}
